import { fromJS } from 'immutable'
import { RxWidgetCacheAPI, WidgetCacheAPI, json, checkStatus } from '@driftt/dapper'

export const api = {
  fetch() {
    return RxWidgetCacheAPI.get(`/embeds/_default`)
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(fromJS)
  },

  fetchById(embedId) {
    return RxWidgetCacheAPI.get(`/embeds/${embedId}`)
      .checkStatus()
      .retryWithBackoff(1)
      .mapResponse(fromJS)
  },

  updateEmbedSettings(operations) {
    return WidgetCacheAPI.patch(`/embeds/_default/configuration`, operations)
      .then(checkStatus)
      .then(json)
  },
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/embed/api.js